var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsset1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 528.16 325.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n      fill: #fff;\n      font-family: 'Nunito Sans', sans-serif;\n      font-size: 24px;\n      font-weight: 600;\n      }\n\n      .cls-2 {\n      font-family: 'Nunito Sans', sans-serif;\n      font-size: 24px;\n      font-weight: 600;\n      }\n\n      .cls-4 {\n      letter-spacing: 0em;\n      }\n\n      .cls-5 {\n      letter-spacing: -.01em;\n      }\n\n      .cls-6 {\n      letter-spacing: -.01em;\n      }\n\n      .cls-7 {\n      letter-spacing: 0em;\n      }\n\n      .cls-8 {\n      letter-spacing: 0em;\n      }\n\n      .cls-9 {\n      letter-spacing: 0em;\n      }\n\n      .cls-10 {\n      fill: #8cc76d;\n      }\n\n      .cls-10, .cls-3 {\n      font-family: 'Nunito Sans', sans-serif;\n      font-size: 60px;\n      font-weight: 800;\n      }\n\n      .cls-11 {\n      letter-spacing: 0em;\n      }\n\n      .cls-12 {\n      fill: none;\n      stroke: #fff;\n      stroke-miterlimit: 10;\n      stroke-width: .5px;\n      }\n\n      .cls-13 {\n      letter-spacing: -.02em;\n      }\n\n      .cls-14 {\n      letter-spacing: 0em;\n      }\n\n      .cls-15 {\n      letter-spacing: 0em;\n      }\n\n      .cls-16 {\n      letter-spacing: 0em;\n      }\n\n      .cls-17 {\n      letter-spacing: 0em;\n      }\n\n      .cls-18 {\n      letter-spacing: 0em;\n      }\n\n      .cls-19 {\n      letter-spacing: -.01em;\n      }\n\n      .cls-20 {\n      letter-spacing: 0em;\n      }\n\n      .cls-21 {\n      letter-spacing: 0em;\n      }\n\n      .cls-22 {\n      letter-spacing: -.01em;\n      }\n\n      .cls-23 {\n      letter-spacing: 0em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(1.26 51.15)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Analysis"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 0,
    y: 72
  }, "tool"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 0,
    y: 144
  }, "for")), /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(103.71 194.76)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Prescriptions")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(0 245.06)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "An effective method for health care"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 28.8
  }, "providers to navigate through "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 57.6
  }, "prescription leaflets")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3",
    transform: "matrix(1 0 0 1 12.5067 -19.4101)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "399.67 153.39 420.04 169.64 444.29 160.12 448.18 134.35 427.81 118.11 403.55 127.63 399.67 153.39"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 420.03,
    cy: 169.63,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 444.29,
    cy: 160.12,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.55,
    cy: 127.63,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 448.17,
    cy: 134.35,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 399.68,
    cy: 153.4,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 427.82,
    cy: 118.12,
    r: 1.4
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "387.08 85.63 383.19 111.39 403.57 127.64 427.82 118.12"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "338.58 104.68 358.95 120.92 383.21 111.4 387.09 85.64 366.72 69.39 342.47 78.91 338.58 104.68"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 358.95,
    cy: 120.92,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.21,
    cy: 111.4,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 342.47,
    cy: 78.91,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 387.09,
    cy: 85.63,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 338.6,
    cy: 104.69,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 366.74,
    cy: 69.4,
    r: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "281.32 30.15 277.44 55.91 297.81 72.16"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 297.8,
    cy: 72.15,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 281.32,
    cy: 30.15,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 277.45,
    cy: 55.92,
    r: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "249.3 91.19 269.67 107.44 293.92 97.92 297.81 72.16 277.44 55.91 253.18 65.43 249.3 91.19"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 269.66,
    cy: 107.44,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 293.92,
    cy: 97.92,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 253.18,
    cy: 65.43,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 297.8,
    cy: 72.15,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 249.31,
    cy: 91.21,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 277.45,
    cy: 55.92,
    r: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "297.84 72.18 293.96 97.95 314.33 114.2 338.58 104.68 342.47 78.91"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 314.32,
    cy: 114.19,
    r: 1.4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset1);
export default __webpack_public_path__ + "static/media/Asset1.e25bf2553fadd2d7063b44f303fb2e2f.svg";
export { ForwardRef as ReactComponent };